import { ComponentType } from "react";

import * as allIcons from "shared/assets/icons";

export enum ICONS {
  concertSing = "concertSing",
  concertMicrophone = "concertMicrophone",
  concertDj = "concertDj",
  concertGuitarist = "concertGuitarist",
  concertCoupleDuet = "concertCoupleDuet",
  partyMusicDance = "partyMusicDance",
  showPerson = "showPerson",
  showTheaterMasks = "showTheaterMasks",
  partyMask = "partyMask",
  nightClubDiscoBall = "nightClubDiscoBall",
  colosseum = "colosseum",
  circusTent = "circusTent",
  campingTent = "campingTent",
  concertBeach = "concertBeach",
  beachParasolWater = "beachParasolWater",
  outdoorsLandscape = "outdoorsLandscape",
  parkBench = "parkBench",
  trees = "trees",
  planet = "planet",
  earthModel = "earthModel",
  houseEntrance = "houseEntrance",
  houseRoof = "houseRoof",
  rewind = "rewind",
  stopControl = "stopControl",
  pause = "pause",
  fastForward = "fastForward",
  musicNote2 = "musicNote2",
  musicNote1 = "musicNote1",
  loveSong = "loveSong",
  playlist = "playlist",
  pacmanMusic = "pacmanMusic",
  concertSpeakers = "concertSpeakers",
  speakerNote = "speakerNote",
  stage = "stage",
  singleMusic = "singleMusic",
  bookMusic = "bookMusic",
  folderMusic = "folderMusic",
  microphoneStudio = "microphoneStudio",
  microphonePodcast = "microphonePodcast",
  microphoneOnAir = "microphoneOnAir",
  microphone = "microphone",
  volume = "volume",
  userLive = "userLive",
  headphones = "headphones",
  walkman = "walkman",
  hearing = "hearing",
  guitarPick = "guitarPick",
  guitar = "guitar",
  drums = "drums",
  pianoKeys = "pianoKeys",
  trumpet = "trumpet",
  metronome = "metronome",
  mixingDesk = "mixingDesk",
  fader = "fader",
  concertRock = "concertRock",
  concertTicket = "concertTicket",
  turntable = "turntable",
  radio = "radio",
  cameraFlash = "cameraFlash",
  vintageCamera = "vintageCamera",
  camera = "camera",
  videoPlayer = "videoPlayer",
  takingPhotos = "takingPhotos",
  filming = "filming",
  computer = "computer",
  laptop = "laptop",
  floppyDisk = "floppyDisk",
  phoneLandline = "phoneLandline",
  phoneMobile = "phoneMobile",
  wifiSignal = "wifiSignal",
  readEmail = "readEmail",
  envelope = "envelope",
  envelopeCircle = "envelopeCircle",
  flight = "flight",
  carGarage = "carGarage",
  parking = "parking",
  truck = "truck",
  train = "train",
  bicycle = "bicycle",
  forklift = "forklift",
  ambulance = "ambulance",
  chopper = "chopper",
  drone = "drone",
  gasCan = "gasCan",
  trafficLights = "trafficLights",
  hotel = "hotel",
  roomservice = "roomservice",
  baggageCart = "baggageCart",
  baggage = "baggage",
  billinginfo = "billinginfo",
  dressingHanger = "dressingHanger",
  hanger = "hanger",
  dressingRoom = "dressingRoom",
  shirt = "shirt",
  shower = "shower",
  armchair = "armchair",
  makeUpChair = "makeUpChair",
  americanFootball = "americanFootball",
  baseball = "baseball",
  fitness = "fitness",
  tennis = "tennis",
  chess = "chess",
  swimmingpoolStairs = "swimmingpoolStairs",
  swimmingpoolPerson = "swimmingpoolPerson",
  soccer = "soccer",
  catering = "catering",
  cutlery = "cutlery",
  burger = "burger",
  croissant = "croissant",
  cookie = "cookie",
  candy = "candy",
  glass = "glass",
  coffee = "coffee",
  champagne = "champagne",
  cocktail = "cocktail",
  snail = "snail",
  userMultiple = "userMultiple",
  singleMegaphone = "singleMegaphone",
  informationDesk = "informationDesk",
  messagesPeopleBubble = "messagesPeopleBubble",
  nurse = "nurse",
  doctor = "doctor",
  womanDj = "womanDj",
  manDj = "manDj",
  smiley = "smiley",
  heart = "heart",
  messagesBubble = "messagesBubble",
  skull = "skull",
  pacman = "pacman",
  robot = "robot",
  confetti = "confetti",
  megaphone = "megaphone",
  binocular = "binocular",
  lifebuoy = "lifebuoy",
  laundry = "laundry",
  powerPlug = "powerPlug",
  electricity = "electricity",
  hammer = "hammer",
  settings = "settings",
  screwdriver = "screwdriver",
  measure = "measure",
  safetyHelmet = "safetyHelmet",
  crown = "crown",
  scissors = "scissors",
  attachment = "attachment",
  handPointing = "handPointing",
  ecology = "ecology",
  arrangeNumber = "arrangeNumber",
  arrangeLetter = "arrangeLetter",
  listBullets = "listBullets",
  listNumbers = "listNumbers",
  bookmarks = "bookmarks",
  listTasks = "listTasks",
  contact = "contact",
  calendar = "calendar",
  planning = "planning",
  clock = "clock",
  stopwatch = "stopwatch",
  alarmClock = "alarmClock",
  alarmBell = "alarmBell",
  weatherSun = "weatherSun",
  weatherSunDark = "weatherSunDark",
  sunset = "sunset",
  weatherCloud = "weatherCloud",
  weatherCloudRain = "weatherCloudRain",
  umbrella = "umbrella",
  thermometer = "thermometer",
  compass = "compass",
  globeArrow = "globeArrow",
  location = "location",
  meetingPoint = "meetingPoint",
  questionCircle = "questionCircle",
  alertCircle = "alertCircle",
  warning = "warning",
  checkBadge = "checkBadge",
  graph = "graph",
  loading = "loading",
  refresh = "refresh",
  powerButton = "powerButton",
  password = "password",
  search = "search",
  zoomIn = "zoomIn",
  ticketCheck = "ticketCheck",
  tagsCash = "tagsCash",
  creditcard = "creditcard",
  shoppingcart = "shoppingcart",
  currency = "currency",
  dollar = "dollar",
  allBands = "allBands",
  cd = "cd",
  tv = "tv",
  cctv = "cctv",
  wifi = "wifi",
  car = "car",
  taxi = "taxi",
  bus = "bus",
  boat = "boat",
  spa = "spa",
  key = "key",
  door = "door",
  golf = "golf",
  yoga = "yoga",
  chef = "chef",
  cake = "cake",
  beer = "beer",
  crab = "crab",
  bug = "bug",
  star = "star",
  eye = "eye",
  gift = "gift",
  iron = "iron",
  cap = "cap",
  bin = "bin",
  hand = "hand",
  like = "like",
  note = "note",
  bulb = "bulb",
  fire = "fire",
  map = "map",
  pin = "pin",
  flag = "flag",
  cog = "cog",
  lock = "lock",
  tags = "tags",
  play = "play",
}

export const iconMap: Record<ICONS, { key: ICONS; icon: ComponentType<any> }> =
  {
    [ICONS.concertSing]: {
      key: ICONS.concertSing,
      icon: allIcons.ConcertSing,
    },
    [ICONS.concertMicrophone]: {
      key: ICONS.concertMicrophone,
      icon: allIcons.ConcertMicrophone,
    },
    [ICONS.concertDj]: {
      key: ICONS.concertDj,
      icon: allIcons.ConcertDj,
    },
    [ICONS.concertGuitarist]: {
      key: ICONS.concertGuitarist,
      icon: allIcons.ConcertGuitarist,
    },
    [ICONS.concertCoupleDuet]: {
      key: ICONS.concertCoupleDuet,
      icon: allIcons.ConcertCoupleDuet,
    },
    [ICONS.partyMusicDance]: {
      key: ICONS.partyMusicDance,
      icon: allIcons.PartyMusicDance,
    },
    [ICONS.showPerson]: {
      key: ICONS.showPerson,
      icon: allIcons.ShowPerson,
    },
    [ICONS.showTheaterMasks]: {
      key: ICONS.showTheaterMasks,
      icon: allIcons.ShowTheaterMasks,
    },
    [ICONS.partyMask]: {
      key: ICONS.partyMask,
      icon: allIcons.PartyMask,
    },
    [ICONS.nightClubDiscoBall]: {
      key: ICONS.nightClubDiscoBall,
      icon: allIcons.NightClubDiscoBall,
    },
    [ICONS.colosseum]: {
      key: ICONS.colosseum,
      icon: allIcons.Colosseum,
    },
    [ICONS.circusTent]: {
      key: ICONS.circusTent,
      icon: allIcons.CircusTent,
    },
    [ICONS.campingTent]: {
      key: ICONS.campingTent,
      icon: allIcons.CampingTent,
    },
    [ICONS.concertBeach]: {
      key: ICONS.concertBeach,
      icon: allIcons.ConcertBeach,
    },
    [ICONS.beachParasolWater]: {
      key: ICONS.beachParasolWater,
      icon: allIcons.BeachParasolWater,
    },
    [ICONS.outdoorsLandscape]: {
      key: ICONS.outdoorsLandscape,
      icon: allIcons.OutdoorsLandscape,
    },
    [ICONS.parkBench]: {
      key: ICONS.parkBench,
      icon: allIcons.ParkBench,
    },
    [ICONS.trees]: {
      key: ICONS.trees,
      icon: allIcons.Trees,
    },
    [ICONS.planet]: {
      key: ICONS.planet,
      icon: allIcons.Planet,
    },
    [ICONS.earthModel]: {
      key: ICONS.earthModel,
      icon: allIcons.EarthModel,
    },
    [ICONS.houseEntrance]: {
      key: ICONS.houseEntrance,
      icon: allIcons.HouseEntrance,
    },
    [ICONS.houseRoof]: {
      key: ICONS.houseRoof,
      icon: allIcons.HouseRoof,
    },
    [ICONS.rewind]: {
      key: ICONS.rewind,
      icon: allIcons.Rewind,
    },
    [ICONS.play]: {
      key: ICONS.play,
      icon: allIcons.Play,
    },
    [ICONS.stopControl]: {
      key: ICONS.stopControl,
      icon: allIcons.StopControl,
    },
    [ICONS.pause]: {
      key: ICONS.pause,
      icon: allIcons.Pause,
    },
    [ICONS.fastForward]: {
      key: ICONS.fastForward,
      icon: allIcons.FastForward,
    },
    [ICONS.musicNote2]: {
      key: ICONS.musicNote2,
      icon: allIcons.MusicNote2,
    },
    [ICONS.musicNote1]: {
      key: ICONS.musicNote1,
      icon: allIcons.MusicNote1,
    },
    [ICONS.loveSong]: {
      key: ICONS.loveSong,
      icon: allIcons.LoveSong,
    },
    [ICONS.playlist]: {
      key: ICONS.playlist,
      icon: allIcons.Playlist,
    },
    [ICONS.pacmanMusic]: {
      key: ICONS.pacmanMusic,
      icon: allIcons.PacmanMusic,
    },
    [ICONS.concertSpeakers]: {
      key: ICONS.concertSpeakers,
      icon: allIcons.ConcertSpeakers,
    },
    [ICONS.speakerNote]: {
      key: ICONS.speakerNote,
      icon: allIcons.SpeakerNote,
    },
    [ICONS.stage]: {
      key: ICONS.stage,
      icon: allIcons.Stage,
    },
    [ICONS.singleMusic]: {
      key: ICONS.singleMusic,
      icon: allIcons.SingleMusic,
    },
    [ICONS.bookMusic]: {
      key: ICONS.bookMusic,
      icon: allIcons.BookMusic,
    },
    [ICONS.folderMusic]: {
      key: ICONS.folderMusic,
      icon: allIcons.FolderMusic,
    },
    [ICONS.microphoneStudio]: {
      key: ICONS.microphoneStudio,
      icon: allIcons.MicrophoneStudio,
    },
    [ICONS.microphonePodcast]: {
      key: ICONS.microphonePodcast,
      icon: allIcons.MicrophonePodcast,
    },
    [ICONS.microphoneOnAir]: {
      key: ICONS.microphoneOnAir,
      icon: allIcons.MicrophoneOnAir,
    },
    [ICONS.microphone]: {
      key: ICONS.microphone,
      icon: allIcons.Microphone,
    },
    [ICONS.volume]: {
      key: ICONS.volume,
      icon: allIcons.Volume,
    },
    [ICONS.userLive]: {
      key: ICONS.userLive,
      icon: allIcons.UserLive,
    },
    [ICONS.headphones]: {
      key: ICONS.headphones,
      icon: allIcons.Headphones,
    },
    [ICONS.walkman]: {
      key: ICONS.walkman,
      icon: allIcons.Walkman,
    },
    [ICONS.hearing]: {
      key: ICONS.hearing,
      icon: allIcons.Hearing,
    },
    [ICONS.guitarPick]: {
      key: ICONS.guitarPick,
      icon: allIcons.GuitarPick,
    },
    [ICONS.guitar]: {
      key: ICONS.guitar,
      icon: allIcons.Guitar,
    },
    [ICONS.drums]: {
      key: ICONS.drums,
      icon: allIcons.Drums,
    },
    [ICONS.pianoKeys]: {
      key: ICONS.pianoKeys,
      icon: allIcons.PianoKeys,
    },
    [ICONS.trumpet]: {
      key: ICONS.trumpet,
      icon: allIcons.Trumpet,
    },
    [ICONS.metronome]: {
      key: ICONS.metronome,
      icon: allIcons.Metronome,
    },
    [ICONS.cd]: {
      key: ICONS.cd,
      icon: allIcons.Cd,
    },
    [ICONS.mixingDesk]: {
      key: ICONS.mixingDesk,
      icon: allIcons.MixingDesk,
    },
    [ICONS.fader]: {
      key: ICONS.fader,
      icon: allIcons.Fader,
    },
    [ICONS.concertRock]: {
      key: ICONS.concertRock,
      icon: allIcons.ConcertRock,
    },
    [ICONS.concertTicket]: {
      key: ICONS.concertTicket,
      icon: allIcons.ConcertTicket,
    },
    [ICONS.turntable]: {
      key: ICONS.turntable,
      icon: allIcons.Turntable,
    },
    [ICONS.radio]: {
      key: ICONS.radio,
      icon: allIcons.Radio,
    },
    [ICONS.tv]: {
      key: ICONS.tv,
      icon: allIcons.Tv,
    },
    [ICONS.cameraFlash]: {
      key: ICONS.cameraFlash,
      icon: allIcons.CameraFlash,
    },
    [ICONS.vintageCamera]: {
      key: ICONS.vintageCamera,
      icon: allIcons.VintageCamera,
    },
    [ICONS.camera]: {
      key: ICONS.camera,
      icon: allIcons.Camera,
    },
    [ICONS.cctv]: {
      key: ICONS.cctv,
      icon: allIcons.Cctv,
    },
    [ICONS.videoPlayer]: {
      key: ICONS.videoPlayer,
      icon: allIcons.VideoPlayer,
    },
    [ICONS.takingPhotos]: {
      key: ICONS.takingPhotos,
      icon: allIcons.TakingPhotos,
    },
    [ICONS.filming]: {
      key: ICONS.filming,
      icon: allIcons.Filming,
    },
    [ICONS.computer]: {
      key: ICONS.computer,
      icon: allIcons.Computer,
    },
    [ICONS.laptop]: {
      key: ICONS.laptop,
      icon: allIcons.Laptop,
    },
    [ICONS.floppyDisk]: {
      key: ICONS.floppyDisk,
      icon: allIcons.FloppyDisk,
    },
    [ICONS.phoneLandline]: {
      key: ICONS.phoneLandline,
      icon: allIcons.PhoneLandline,
    },
    [ICONS.phoneMobile]: {
      key: ICONS.phoneMobile,
      icon: allIcons.PhoneMobile,
    },
    [ICONS.wifiSignal]: {
      key: ICONS.wifiSignal,
      icon: allIcons.WifiSignal,
    },
    [ICONS.wifi]: {
      key: ICONS.wifi,
      icon: allIcons.Wifi,
    },
    [ICONS.readEmail]: {
      key: ICONS.readEmail,
      icon: allIcons.ReadEmail,
    },
    [ICONS.envelope]: {
      key: ICONS.envelope,
      icon: allIcons.Envelope,
    },
    [ICONS.envelopeCircle]: {
      key: ICONS.envelopeCircle,
      icon: allIcons.EnvelopeCircle,
    },
    [ICONS.flight]: {
      key: ICONS.flight,
      icon: allIcons.Flight,
    },
    [ICONS.car]: {
      key: ICONS.car,
      icon: allIcons.Car,
    },
    [ICONS.taxi]: {
      key: ICONS.taxi,
      icon: allIcons.Taxi,
    },
    [ICONS.carGarage]: {
      key: ICONS.carGarage,
      icon: allIcons.CarGarage,
    },
    [ICONS.parking]: {
      key: ICONS.parking,
      icon: allIcons.Parking,
    },
    [ICONS.bus]: {
      key: ICONS.bus,
      icon: allIcons.Bus,
    },
    [ICONS.truck]: {
      key: ICONS.truck,
      icon: allIcons.Truck,
    },
    [ICONS.train]: {
      key: ICONS.train,
      icon: allIcons.Train,
    },
    [ICONS.boat]: {
      key: ICONS.boat,
      icon: allIcons.Boat,
    },
    [ICONS.bicycle]: {
      key: ICONS.bicycle,
      icon: allIcons.Bicycle,
    },
    [ICONS.forklift]: {
      key: ICONS.forklift,
      icon: allIcons.Forklift,
    },
    [ICONS.ambulance]: {
      key: ICONS.ambulance,
      icon: allIcons.Ambulance,
    },
    [ICONS.chopper]: {
      key: ICONS.chopper,
      icon: allIcons.Chopper,
    },
    [ICONS.drone]: {
      key: ICONS.drone,
      icon: allIcons.Drone,
    },
    [ICONS.gasCan]: {
      key: ICONS.gasCan,
      icon: allIcons.GasCan,
    },
    [ICONS.trafficLights]: {
      key: ICONS.trafficLights,
      icon: allIcons.TrafficLights,
    },
    [ICONS.hotel]: {
      key: ICONS.hotel,
      icon: allIcons.Hotel,
    },
    [ICONS.spa]: {
      key: ICONS.spa,
      icon: allIcons.Spa,
    },
    [ICONS.roomservice]: {
      key: ICONS.roomservice,
      icon: allIcons.Roomservice,
    },
    [ICONS.baggageCart]: {
      key: ICONS.baggageCart,
      icon: allIcons.BaggageCart,
    },
    [ICONS.baggage]: {
      key: ICONS.baggage,
      icon: allIcons.Baggage,
    },
    [ICONS.billinginfo]: {
      key: ICONS.billinginfo,
      icon: allIcons.Billinginfo,
    },
    [ICONS.dressingHanger]: {
      key: ICONS.dressingHanger,
      icon: allIcons.DressingHanger,
    },
    [ICONS.hanger]: {
      key: ICONS.hanger,
      icon: allIcons.Hanger,
    },
    [ICONS.dressingRoom]: {
      key: ICONS.dressingRoom,
      icon: allIcons.DressingRoom,
    },
    [ICONS.shirt]: {
      key: ICONS.shirt,
      icon: allIcons.Shirt,
    },
    [ICONS.shower]: {
      key: ICONS.shower,
      icon: allIcons.Shower,
    },
    [ICONS.key]: {
      key: ICONS.key,
      icon: allIcons.Key,
    },
    [ICONS.door]: {
      key: ICONS.door,
      icon: allIcons.Door,
    },
    [ICONS.armchair]: {
      key: ICONS.armchair,
      icon: allIcons.Armchair,
    },
    [ICONS.makeUpChair]: {
      key: ICONS.makeUpChair,
      icon: allIcons.MakeUpChair,
    },
    [ICONS.americanFootball]: {
      key: ICONS.americanFootball,
      icon: allIcons.AmericanFootball,
    },
    [ICONS.baseball]: {
      key: ICONS.baseball,
      icon: allIcons.Baseball,
    },
    [ICONS.fitness]: {
      key: ICONS.fitness,
      icon: allIcons.Fitness,
    },
    [ICONS.tennis]: {
      key: ICONS.tennis,
      icon: allIcons.Tennis,
    },
    [ICONS.chess]: {
      key: ICONS.chess,
      icon: allIcons.Chess,
    },
    [ICONS.golf]: {
      key: ICONS.golf,
      icon: allIcons.Golf,
    },
    [ICONS.swimmingpoolStairs]: {
      key: ICONS.swimmingpoolStairs,
      icon: allIcons.SwimmingpoolStairs,
    },
    [ICONS.swimmingpoolPerson]: {
      key: ICONS.swimmingpoolPerson,
      icon: allIcons.SwimmingpoolPerson,
    },
    [ICONS.soccer]: {
      key: ICONS.soccer,
      icon: allIcons.Soccer,
    },
    [ICONS.yoga]: {
      key: ICONS.yoga,
      icon: allIcons.Yoga,
    },
    [ICONS.chef]: {
      key: ICONS.chef,
      icon: allIcons.Chef,
    },
    [ICONS.catering]: {
      key: ICONS.catering,
      icon: allIcons.Catering,
    },
    [ICONS.cutlery]: {
      key: ICONS.cutlery,
      icon: allIcons.Cutlery,
    },
    [ICONS.burger]: {
      key: ICONS.burger,
      icon: allIcons.Burger,
    },
    [ICONS.croissant]: {
      key: ICONS.croissant,
      icon: allIcons.Croissant,
    },
    [ICONS.cookie]: {
      key: ICONS.cookie,
      icon: allIcons.Cookie,
    },
    [ICONS.candy]: {
      key: ICONS.candy,
      icon: allIcons.Candy,
    },
    [ICONS.cake]: {
      key: ICONS.cake,
      icon: allIcons.Cake,
    },
    [ICONS.glass]: {
      key: ICONS.glass,
      icon: allIcons.Glass,
    },
    [ICONS.coffee]: {
      key: ICONS.coffee,
      icon: allIcons.Coffee,
    },
    [ICONS.beer]: {
      key: ICONS.beer,
      icon: allIcons.Beer,
    },
    [ICONS.champagne]: {
      key: ICONS.champagne,
      icon: allIcons.Champagne,
    },
    [ICONS.cocktail]: {
      key: ICONS.cocktail,
      icon: allIcons.Cocktail,
    },
    [ICONS.crab]: {
      key: ICONS.crab,
      icon: allIcons.Crab,
    },
    [ICONS.snail]: {
      key: ICONS.snail,
      icon: allIcons.Snail,
    },
    [ICONS.bug]: {
      key: ICONS.bug,
      icon: allIcons.Bug,
    },
    [ICONS.userMultiple]: {
      key: ICONS.userMultiple,
      icon: allIcons.UserMultiple,
    },
    [ICONS.singleMegaphone]: {
      key: ICONS.singleMegaphone,
      icon: allIcons.SingleMegaphone,
    },
    [ICONS.informationDesk]: {
      key: ICONS.informationDesk,
      icon: allIcons.InformationDesk,
    },
    [ICONS.messagesPeopleBubble]: {
      key: ICONS.messagesPeopleBubble,
      icon: allIcons.MessagesPeopleBubble,
    },
    [ICONS.nurse]: {
      key: ICONS.nurse,
      icon: allIcons.Nurse,
    },
    [ICONS.doctor]: {
      key: ICONS.doctor,
      icon: allIcons.Doctor,
    },
    [ICONS.womanDj]: {
      key: ICONS.womanDj,
      icon: allIcons.WomanDj,
    },
    [ICONS.manDj]: {
      key: ICONS.manDj,
      icon: allIcons.ManDj,
    },
    [ICONS.star]: {
      key: ICONS.star,
      icon: allIcons.Star,
    },
    [ICONS.smiley]: {
      key: ICONS.smiley,
      icon: allIcons.Smiley,
    },
    [ICONS.heart]: {
      key: ICONS.heart,
      icon: allIcons.Heart,
    },
    [ICONS.messagesBubble]: {
      key: ICONS.messagesBubble,
      icon: allIcons.MessagesBubble,
    },
    [ICONS.skull]: {
      key: ICONS.skull,
      icon: allIcons.Skull,
    },
    [ICONS.pacman]: {
      key: ICONS.pacman,
      icon: allIcons.Pacman,
    },
    [ICONS.eye]: {
      key: ICONS.eye,
      icon: allIcons.Eye,
    },
    [ICONS.robot]: {
      key: ICONS.robot,
      icon: allIcons.Robot,
    },
    [ICONS.confetti]: {
      key: ICONS.confetti,
      icon: allIcons.Confetti,
    },
    [ICONS.gift]: {
      key: ICONS.gift,
      icon: allIcons.Gift,
    },
    [ICONS.megaphone]: {
      key: ICONS.megaphone,
      icon: allIcons.Megaphone,
    },
    [ICONS.binocular]: {
      key: ICONS.binocular,
      icon: allIcons.Binocular,
    },
    [ICONS.lifebuoy]: {
      key: ICONS.lifebuoy,
      icon: allIcons.Lifebuoy,
    },
    [ICONS.laundry]: {
      key: ICONS.laundry,
      icon: allIcons.Laundry,
    },
    [ICONS.iron]: {
      key: ICONS.iron,
      icon: allIcons.Iron,
    },
    [ICONS.powerPlug]: {
      key: ICONS.powerPlug,
      icon: allIcons.PowerPlug,
    },
    [ICONS.electricity]: {
      key: ICONS.electricity,
      icon: allIcons.Electricity,
    },
    [ICONS.hammer]: {
      key: ICONS.hammer,
      icon: allIcons.Hammer,
    },
    [ICONS.settings]: {
      key: ICONS.settings,
      icon: allIcons.Settings,
    },
    [ICONS.screwdriver]: {
      key: ICONS.screwdriver,
      icon: allIcons.Screwdriver,
    },
    [ICONS.measure]: {
      key: ICONS.measure,
      icon: allIcons.Measure,
    },
    [ICONS.safetyHelmet]: {
      key: ICONS.safetyHelmet,
      icon: allIcons.SafetyHelmet,
    },
    [ICONS.cap]: {
      key: ICONS.cap,
      icon: allIcons.Cap,
    },
    [ICONS.crown]: {
      key: ICONS.crown,
      icon: allIcons.Crown,
    },
    [ICONS.scissors]: {
      key: ICONS.scissors,
      icon: allIcons.Scissors,
    },
    [ICONS.bin]: {
      key: ICONS.bin,
      icon: allIcons.Bin,
    },
    [ICONS.attachment]: {
      key: ICONS.attachment,
      icon: allIcons.Attachment,
    },
    [ICONS.hand]: {
      key: ICONS.hand,
      icon: allIcons.Hand,
    },
    [ICONS.handPointing]: {
      key: ICONS.handPointing,
      icon: allIcons.HandPointing,
    },
    [ICONS.like]: {
      key: ICONS.like,
      icon: allIcons.Like,
    },
    [ICONS.ecology]: {
      key: ICONS.ecology,
      icon: allIcons.Ecology,
    },
    [ICONS.arrangeNumber]: {
      key: ICONS.arrangeNumber,
      icon: allIcons.ArrangeNumber,
    },
    [ICONS.arrangeLetter]: {
      key: ICONS.arrangeLetter,
      icon: allIcons.ArrangeLetter,
    },
    [ICONS.listBullets]: {
      key: ICONS.listBullets,
      icon: allIcons.ListBullets,
    },
    [ICONS.listNumbers]: {
      key: ICONS.listNumbers,
      icon: allIcons.ListNumbers,
    },
    [ICONS.bookmarks]: {
      key: ICONS.bookmarks,
      icon: allIcons.Bookmarks,
    },
    [ICONS.listTasks]: {
      key: ICONS.listTasks,
      icon: allIcons.ListTasks,
    },
    [ICONS.note]: {
      key: ICONS.note,
      icon: allIcons.Note,
    },
    [ICONS.contact]: {
      key: ICONS.contact,
      icon: allIcons.Contact,
    },
    [ICONS.calendar]: {
      key: ICONS.calendar,
      icon: allIcons.Calendar,
    },
    [ICONS.planning]: {
      key: ICONS.planning,
      icon: allIcons.Planning,
    },
    [ICONS.clock]: {
      key: ICONS.clock,
      icon: allIcons.Clock,
    },
    [ICONS.stopwatch]: {
      key: ICONS.stopwatch,
      icon: allIcons.Stopwatch,
    },
    [ICONS.alarmClock]: {
      key: ICONS.alarmClock,
      icon: allIcons.AlarmClock,
    },
    [ICONS.alarmBell]: {
      key: ICONS.alarmBell,
      icon: allIcons.AlarmBell,
    },
    [ICONS.bulb]: {
      key: ICONS.bulb,
      icon: allIcons.Bulb,
    },
    [ICONS.weatherSun]: {
      key: ICONS.weatherSun,
      icon: allIcons.WeatherSun,
    },
    [ICONS.weatherSunDark]: {
      key: ICONS.weatherSunDark,
      icon: allIcons.WeatherSunDark,
    },
    [ICONS.sunset]: {
      key: ICONS.sunset,
      icon: allIcons.Sunset,
    },
    [ICONS.weatherCloud]: {
      key: ICONS.weatherCloud,
      icon: allIcons.WeatherCloud,
    },
    [ICONS.weatherCloudRain]: {
      key: ICONS.weatherCloudRain,
      icon: allIcons.WeatherCloudRain,
    },
    [ICONS.umbrella]: {
      key: ICONS.umbrella,
      icon: allIcons.Umbrella,
    },
    [ICONS.thermometer]: {
      key: ICONS.thermometer,
      icon: allIcons.Thermometer,
    },
    [ICONS.fire]: {
      key: ICONS.fire,
      icon: allIcons.Fire,
    },
    [ICONS.compass]: {
      key: ICONS.compass,
      icon: allIcons.Compass,
    },
    [ICONS.map]: {
      key: ICONS.map,
      icon: allIcons.Map,
    },
    [ICONS.globeArrow]: {
      key: ICONS.globeArrow,
      icon: allIcons.GlobeArrow,
    },
    [ICONS.location]: {
      key: ICONS.location,
      icon: allIcons.Location,
    },
    [ICONS.pin]: {
      key: ICONS.pin,
      icon: allIcons.Pin,
    },
    [ICONS.meetingPoint]: {
      key: ICONS.meetingPoint,
      icon: allIcons.MeetingPoint,
    },
    [ICONS.flag]: {
      key: ICONS.flag,
      icon: allIcons.Flag,
    },
    [ICONS.questionCircle]: {
      key: ICONS.questionCircle,
      icon: allIcons.QuestionCircle,
    },
    [ICONS.alertCircle]: {
      key: ICONS.alertCircle,
      icon: allIcons.AlertCircle,
    },
    [ICONS.warning]: {
      key: ICONS.warning,
      icon: allIcons.Warning,
    },
    [ICONS.checkBadge]: {
      key: ICONS.checkBadge,
      icon: allIcons.CheckBadge,
    },
    [ICONS.cog]: {
      key: ICONS.cog,
      icon: allIcons.Cog,
    },
    [ICONS.graph]: {
      key: ICONS.graph,
      icon: allIcons.Graph,
    },
    [ICONS.loading]: {
      key: ICONS.loading,
      icon: allIcons.Loading,
    },
    [ICONS.refresh]: {
      key: ICONS.refresh,
      icon: allIcons.Refresh,
    },
    [ICONS.powerButton]: {
      key: ICONS.powerButton,
      icon: allIcons.PowerButton,
    },
    [ICONS.lock]: {
      key: ICONS.lock,
      icon: allIcons.Lock,
    },
    [ICONS.password]: {
      key: ICONS.password,
      icon: allIcons.Password,
    },
    [ICONS.search]: {
      key: ICONS.search,
      icon: allIcons.Search,
    },
    [ICONS.zoomIn]: {
      key: ICONS.zoomIn,
      icon: allIcons.ZoomIn,
    },
    [ICONS.tags]: {
      key: ICONS.tags,
      icon: allIcons.Tags,
    },
    [ICONS.ticketCheck]: {
      key: ICONS.ticketCheck,
      icon: allIcons.TicketCheck,
    },
    [ICONS.tagsCash]: {
      key: ICONS.tagsCash,
      icon: allIcons.TagsCash,
    },
    [ICONS.creditcard]: {
      key: ICONS.creditcard,
      icon: allIcons.CreditCard,
    },
    [ICONS.shoppingcart]: {
      key: ICONS.shoppingcart,
      icon: allIcons.ShoppingCart,
    },
    [ICONS.currency]: {
      key: ICONS.currency,
      icon: allIcons.Currency,
    },
    [ICONS.dollar]: {
      key: ICONS.dollar,
      icon: allIcons.Dollar,
    },
    [ICONS.allBands]: {
      key: ICONS.allBands,
      icon: allIcons.AllBands,
    },
  };

export const getIcon = (key: string): ComponentType<any> => {
  return (iconMap[key as ICONS] || iconMap[ICONS.allBands]).icon;
};
